import React, { useRef } from 'react';
import '../styles/ContactUs.css';
import InvestmentGuideSection from '../components/InvestmentGuideSection';
import ScrollDownArrow from '../components/ScrollDownArrow';


const ContactUs = () => {
  const formRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Get form values
    const firstName = document.getElementById('firstName').value.trim();
    const lastName = document.getElementById('lastName').value.trim();
    const email = document.getElementById('email').value.trim();
    const contactNumber = document.getElementById('contactNumber').value.trim();
    const message = document.getElementById('message').value.trim();

    // Validation
    if (!firstName) {
      showToast('error', 'First name is required');
      return;
    }

    if (!lastName) {
      showToast('error', 'Last name is required');
      return;
    }

    if (!email) {
      showToast('error', 'Email is required');
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showToast('error', 'Please enter a valid email address');
      return;
    }

    if (!contactNumber) {
      showToast('error', 'Contact number is required');
      return;
    }

    // Phone number validation (allows +, -, and numbers)
    const phoneRegex = /^[+]?[\d\s-]+$/;
    if (!phoneRegex.test(contactNumber)) {
      showToast('error', 'Please enter a valid contact number');
      return;
    }

    if (!message) {
      showToast('error', 'Message is required');
      return;
    }

    if (message.length < 10) {
      showToast('error', 'Message must be at least 10 characters long');
      return;
    }

    const formData = {
      firstName,
      lastName,
      email,
      contactNumber,
      country: document.getElementById('country').value.trim(),
      message
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        showToast('success', 'Your message has been sent successfully. We\'ll get back to you soon!');
        e.target.reset();
      } else {
        showToast('error', data.message || 'Something went wrong');
      }
    } catch (error) {
      console.error('Error:', error);
      showToast('error', 'Failed to send message');
    }
  };

  // Helper function to show toast
  const showToast = (type, message) => {
    const toastDiv = document.createElement('div');
    toastDiv.className = `custom-alert ${type}`;
    toastDiv.innerHTML = `
      <div class="alert-content">
        <div class="icon">${type === 'error' ? '❌' : '✅'}</div>
        <div class="message">
          <h3>${type === 'error' ? 'Error' : 'Success'}</h3>
          <p>${message}</p>
        </div>
      </div>
    `;
    document.body.appendChild(toastDiv);
    
    // Remove toast after 3 seconds
    setTimeout(() => {
      toastDiv.classList.add('toast-exit');
      setTimeout(() => {
        document.body.removeChild(toastDiv);
      }, 300);
    }, 3000);
  };

  return (
    <div className="contact-page">
      {/* Hero Section with Form */}
      <section className="contact-hero large-hero">
        <div className="contact-hero-overlay"></div>
        <div className="contact-hero-content hero-content-with-form">
          <div className="hero-content-left">
            <h1 className="contact-hero-title">Contact Us</h1>
            <h4 className="contact-hero-subtitle">
              Whether you're looking to buy, sell, rent or invest, our property specialists have the knowledge, experience and passion to guide you through your next real estate transaction.
            </h4>
          </div>
          <div className="contact-hero-form-card">
            <h3>Get in Touch</h3>
            <form onSubmit={handleSubmit} ref={formRef} noValidate>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="firstName">First Name</label>
                  <input
                    id="firstName"
                    type="text"
                    minLength={2}
                    maxLength={50}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    id="lastName"
                    type="text"
                    minLength={2}
                    maxLength={50}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                />
              </div>
              <div className="form-group">
                <label htmlFor="contactNumber">Contact Number</label>
                <input
                  id="contactNumber"
                  type="tel"
                  placeholder="Eg: +971-xxx-xxx"
                />
              </div>
              <div className="form-row">
                <div className="form-group" style={{width: '100%'}}>
                  <label htmlFor="country">Country</label>
                  <select id="country" name="country">
                    <option value="">Country</option>
                    <option value="AUS">AUS</option>
                    <option value="UAE">UAE</option>
                    <option value="KSA">KSA</option>
                    <option value="Qatar">Qatar</option>
                    <option value="UK">UK</option>
                    <option value="India">India</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group" style={{width: '100%'}}>
                  <label htmlFor="message">Message</label>
                  <textarea 
                    id="message" 
                    name="message" 
                    rows={4} 
                    minLength={10}
                    maxLength={1000}
                  ></textarea>
                </div>
              </div>
              <div className="form-row">
                <button type="submit" className="contact-btn">Send</button>
              </div>
            </form>
          </div>
        </div>
        <ScrollDownArrow targetSelector=".contact-intro-section" />
      </section>

      {/* Get in Touch Section */}
      <section className="contact-intro-section">
        <p className="contact-intro-subtitle">
          Provide your details and we'll be in touch soon. We look forward to hearing from you.
        </p>
      </section>

      {/* Google Map Section */}
      <section className="contact-map-section">
        <div className="contact-map-card">
          <iframe
            title="ABBASS Global Properties Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.090239520384!2d55.27230847605442!3d25.200179131578686!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f42816b65fbdf%3A0xb295c2645b3d0473!2sBoulevard%20Plaza%20Tower%201!5e0!3m2!1sen!2sau!4v1747215870589!5m2!1sen!2sau"
            width="100%"
            height="340"
            style={{ border: 0, borderRadius: '18px' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      <InvestmentGuideSection />
      
    </div>
  );
};

export default ContactUs; 